import { ITemplate } from '@pia/pia.shared';
import { Injectable } from '@angular/core';
import { TemplateWorkItem } from 'src/app/business/swodoc/template-work-item';
import { IWorkItem } from 'src/app/common/contracts/work-item/work-item_T';

import { Command } from '../command';
import { EntityCommandHandler } from '../entity-command-handler';

@Injectable()
export class TemplateCommandHandler extends EntityCommandHandler<ITemplate> {
  protected workItem: IWorkItem<ITemplate>;

  constructor(templateWorkItem: TemplateWorkItem) {
    super();
    this.workItem = templateWorkItem;
  }

  canHandle(command: Command): boolean {
    return command.dtoName === 'TemplateDto';
  }
}
